<template>
  <div
    class="price notranslate"
    translate="no"
    :class="{
      'u-dp-block' : display === 'block',
      'u-dp-flex' : display === 'flex',
      'u-text-right' : align === 'right',
      'u-text-left' : align === 'left'
    }"
  >
    <slot v-if="$store.getters.isB2b">
      <span class="price__line1 notranslate" title="Netto Preis" translate="no"><slot name="netto"></slot> <small>zzgl. MwSt.</small></span>
      <br class="u-dp-none">
      <small class="price__line2 notranslate" title="Brutto Preis" translate="no"><slot name="brutto"></slot> inkl. MwSt.</small>
    </slot>

    <slot v-else>
      <span class="price__line1 notranslate" title="Brutto Preis" translate="no"><slot name="brutto"></slot> <small>inkl. MwSt.</small></span>
      <br class="u-dp-none">
      <small class="price__line2 notranslate" title="Netto Preis" translate="no"><slot name="netto"></slot> zzgl. MwSt.</small>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    align: {
      type: String,
      default: 'right'
    },
    display: {
      type: String,
      default: 'flex'
    }
  },
  data () {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
/**
 * Price
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Price component
 * @since 2021-08-17
**/

$component: 'price';

.#{$component} {
  // Flex attributes for when flex is activated (default)
  flex-direction: column;

  small {
    @include font-size($font-size-sm);
    font-weight: $font-weight-light;
  }

  &__line1 {
    font-weight: $font-weight-bold;

    > span {
      font-weight: $font-weight-normal;
    }
  }

  &__line2 {
    color: $ink-lightest;
    // margin-top: -2px;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    // zoom: 0.9;
  }
}
</style>
